import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import { z } from "zod";
import type { Database } from "@/integrations/supabase/types";

function isNewKey(v: string) {
  return v.startsWith("sb_publishable_") || v.startsWith("sb_secret_");
}

function client() {
  const url = process.env.SUPABASE_URL;
  const key = process.env.SUPABASE_PUBLISHABLE_KEY;
  if (!url || !key) throw new Error("supabase_env_missing");
  return createClient<Database>(url, key, {
    auth: { storage: undefined, persistSession: false, autoRefreshToken: false },
    global: {
      fetch: (input, init) => {
        const h = new Headers(init?.headers);
        if (isNewKey(key) && h.get("Authorization") === `Bearer ${key}`) h.delete("Authorization");
        h.set("apikey", key);
        return fetch(input, { ...init, headers: h });
      },
    },
  });
}

export const validateCoupon = createServerFn({ method: "POST" })
  .inputValidator((raw: unknown) =>
    z
      .object({
        code: z.string().trim().max(40),
        customer_id: z.string().uuid().optional(),
        total_paise: z.number().int().min(0),
        context: z.record(z.any()).optional().default({}),
      })
      .parse(raw),
  )
  .handler(async ({ data }) => {
    const supabase = client();
    const { data: res, error } = await supabase.rpc("mp2_validate_coupon", {
      _code: data.code.toUpperCase(),
      _customer_id: data.customer_id ?? "00000000-0000-0000-0000-000000000000",
      _total_paise: data.total_paise,
      _context: data.context,
    });
    if (error) throw new Error(`mp2_validate_coupon:${error.message}`);
    return res as any;
  });
